<template>
  <v-container>
    <v-list rounded>
      <div><span>Version: </span>
      <span>{{ version }}</span>
      </div>
      <div v-if="Location">
        <span>Location Code: </span>
        <span id="locationCode">{{ Location.code }}</span>
        <v-btn text icon color="primary" @click="copyCode" small>
          <v-icon small>mdi-content-copy</v-icon>
        </v-btn>
      </div>
      <v-divider></v-divider>
      <v-list-item-group color="primary">
        <!-- <v-list-item>
          <v-list-item-icon>
            <v-icon v-text="'mdi-clock'"></v-icon>
          </v-list-item-icon>
          <v-list-item-content @click="addTimeClockToken">
            <v-list-item-title v-text="'Time Clock'"></v-list-item-title>
          </v-list-item-content>
        </v-list-item> -->

        <v-list-item
           @click="$router.push({name: 'employee-list'})"
        >
          <v-list-item-icon>
            <v-icon>mdi-account</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Employee</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item @click="$router.push({name: 'general-setting'})"
          v-if="employeeAccess.setting && employeeAccess.setting.edit"
        >
          <v-list-item-icon>
            <v-icon>mdi-cog</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Setting</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-divider></v-divider>

        <v-list-item @click.stop.prevent="downloadSupport">
          <v-list-item-icon>
            <v-icon>mdi-face-agent</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Support Software</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list-item-group>
    </v-list>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";
const pjson = require("../../../package.json");

export default {
  data: () => ({
    Location: null,
    items: [
      // { text: "Time Clock", icon: "mdi-clock", route: "/clockInOut" },

      { text: "Employee", icon: "mdi-account", route: "employee" },
      // { text: "Reports", icon: "mdi-flag" },
      { text: "Setting", icon: "mdi-cog", route: "general" },
      // { text: "Switch Location", icon: "mdi-shield-key", route: "/location" },
      // { text: "Logout", icon: "mdi-logout", route: "/logout" },
    ],
  }),
  methods: {
    downloadSupport() {
      window.open(
        "https://play.google.com/store/apps/details?id=com.splashtop.sos&hl=en_US&gl=US"
      );
    },
    copyCode() {
      var copyText = document.getElementById("locationCode");
      console.log("copyText", copyText.innerHTML);

      navigator.clipboard.writeText(copyText.innerHTML);
      this.$toast.success("Location code was copy", { timeout: 2000 });
    },
  },
  created() {
    console.log('employeeAccess', this.employeeAccess)
    this.Location = JSON.parse(
      localStorage.getItem(`${process.env.VUE_APP_STORAGE_PREFIX}location`)
    );
  },
  computed: {
    ...mapGetters("employee", ["employeeAccess"]),
    version() {
      // console.log('pjson', pjson.version)
      return pjson.version;
    },
    generateTimeClockToken() {
      let rand = function () {
        return Math.random().toString(36).substr(2);
      };

      return rand() + rand();
    },
  },
};
</script>